import React from 'react';
import { dateFns } from '../../helpers';

export function WidgetDate ({ date, format = 'dd/MM/yyyy' }) {
    if (!date) return <span>-</span>;
    return (<span>{dateFns.format(date, format)}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetDate.displayName = 'WidgetDate';
}
